import { render, staticRenderFns } from "./NixiaTypingIndicator.vue?vue&type=template&id=0cc8be23&scoped=true&"
import script from "./NixiaTypingIndicator.vue?vue&type=script&lang=js&"
export * from "./NixiaTypingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./NixiaTypingIndicator.vue?vue&type=style&index=0&id=0cc8be23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8be23",
  null
  
)

export default component.exports